export default {
  title: 'Job Location Management',
  menu: 'Job Location Management',
  label: {
    companyName: 'Company Name',
    city: 'City',
    region: 'District',
    cbd: 'CBD',
    address: 'Address',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    excelInput: 'EXCEL File: ',
    uploadLocation: 'Verify Locations',
    addLocation: 'Add Location',
    editLocation: 'Edit Location'
  },
  btn: {
    addLocation: 'Add Location',
    batchUpload: 'Batch Upload',
    selectFile: 'Browse',
    upload: 'Upload Alumni',
    downloadTemplate: 'Download Template',
    cancelUpload: 'Cancel',
    ConfirmUpload: 'Confirm',
    remove: 'Remove'
  },
  placeholder: {
    city: 'Select City',
    status: 'Select Status',
    search: 'Keyword Search'
  },
  message: {
    uploadTip: 'You can only upload a excel file',
    uploadError: 'Upload failed, please upload again',
    uploadSuccess: '{totalCount} locations successfully uploaded. {failedCount} locations already exist.',
    locationIsExisted: 'Oops! Seems this location already exists, you don\'t need to add again.',
    removeLocation: 'Are you sure you want to remove {cityName} - {address}?',
    notAllMatchedGEO: 'Please confirm EACH location has matched correct address, region and CBD.',
    disableLocation: 'Are you sure you want to deactivate this location {address}?',
    onlyLocationTip: 'To deactivate this location, first “close” the following jobs: {locationIds}.'
  }
}
